import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {

  1: { // Exercise num
    unit: 'Unit 3',
    id: 'SB5-U3-P24-E1',
    audio: '',
    video: '',
    component: UI,
    // recorder: true,
    // titleQuestion: [{ num: '1', title: 'Listen to the story and repeat. Act.', color: "#445B9F" }],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page24/2.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'SB5-U3-P24-E2',
    audio: 'img/FriendsPlus/Page24/Audio/audio-e2-p24.mp3',
    video: '',
    component: UI,
    recorder: true,
    // titleQuestion: [{ num: '1', title: 'Listen to the story and repeat. Act.', color: "#445B9F" }],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page24/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page24/E2/2.jpg', audioUrl: "img/FriendsPlus/Page24/Audio/tieude-e2-p24.mp3" },
        { url: 'img/FriendsPlus/Page24/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page24/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page24/E2/5.jpg', audioUrl: "img/FriendsPlus/Page24/Audio/doantren.mp3" },
        { url: 'img/FriendsPlus/Page24/E2/6.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page24/E2/7.jpg', audioUrl: "img/FriendsPlus/Page24/Audio/doanduoi.mp3" },
        { url: 'img/FriendsPlus/Page24/E2/8.jpg', audioUrl: "img/FriendsPlus/Page24/Audio/doanbenphai.mp3" },
      ],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 3',
    id: 'SB5-U3-P24-E3',
    audio: '',
    video: '',
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page24/4.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page24/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page24/E2/5.jpg', },
        { url: 'img/FriendsPlus/Page24/E2/6.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page24/E2/7.jpg', },
        { url: 'img/FriendsPlus/Page24/E2/8.jpg', },
      ],
    ],
  },
  4: { // Exercise num
    unit: 'Unit 3',
    id: 'SB5-U3-P24-E4',
    audio: '',
    video: '',
    component: D1,
    padding: 0,
    maxLength: 1,
    textAlign: 'center',
    exerciseKey: 'img/FriendsPlus/Page24/E4/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page24/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page24/E4/2.jpg' },
        { url: 'img/FriendsPlus/Page24/E4/3.jpg', input: true, answer: "V" },
        { url: 'img/FriendsPlus/Page24/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page24/E4/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page24/E4/6.jpg' },
        { url: 'img/FriendsPlus/Page24/E4/7.jpg', input: true, answer: "V" },
        { url: 'img/FriendsPlus/Page24/E4/8.jpg' },
        { url: 'img/FriendsPlus/Page24/E4/9.jpg', input: true, answer: "I" },
        { url: 'img/FriendsPlus/Page24/E4/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page24/E4/11.jpg' },
        { url: 'img/FriendsPlus/Page24/E4/12.jpg', input: true, answer: "J" },
        { url: 'img/FriendsPlus/Page24/E4/13.jpg' },
        { url: 'img/FriendsPlus/Page24/E4/14.jpg', input: true, answer: "I" },
        { url: 'img/FriendsPlus/Page24/E4/15.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page24/E4/16.jpg' },
      ],

    ]
  },

}

export default json;